import { render } from "./ProjectionComparison.vue?vue&type=template&id=5396f05d&scoped=true"
import script from "./ProjectionComparison.vue?vue&type=script&lang=js"
export * from "./ProjectionComparison.vue?vue&type=script&lang=js"

import "./ProjectionComparison.vue?vue&type=style&index=0&id=5396f05d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5396f05d"]])

export default __exports__